/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react'
import * as R from 'ramda'
import urlParser from 'url'
import { Tabs } from 'antd-mobile'
import za from 'za-helper'

// import vConsole from 'vconsole'

import ActivityInfo from '~/modules/ActivityInfo'
import BannerModule from '~/modules/Banner'
import { getActivityById } from '~/services'
import { initOpenInApp, initializeNativeShare } from '~/utils'

import ActivityInstruction from './ActivityInstruction'
import ActivityParticipate from './ActivityParticipate'
import styles from './index.css'

const bannerDataKeys = [
  'title',
  'cover',
  'videoId',
  'bannerType',
  'videoUrl',
  'headBanner',
]
const activitySummaryKeys = ['title', 'browse', 'follow', 'activityFollowed']
const introductionDataKeys = [
  'organization',
  'extensionType',
  'extention',
  'column',
  'introduce',
  'module',
  'showType',
  'defaultDynamicId',
  'experienceCard',
  'live',
  'ebook',
  'innerBanner',
]

// const vconsole = new vConsole() // eslint-disable-line
export default class Home extends Component {
  // showType: 1:流式布局 2:type切换
  // 模块化管理: 1:展示 2:不展示
  // suggestedRead: 推荐阅读; effectChange: 效果转化; activityIntroduce: 活动介绍; awardDeclare: 奖励说明; activityDynamic: 活动动态
  state = {
    currentTab: 0,
    activityDetail: null,
  }

  componentDidMount = () => {
    window.addEventListener('load', this.handlePageInit)
    za.trackPageShow({ id: 2045 })

    this.initPageDateTime = new Date().getTime()

    const { href, pathname } = window.location
    const { match: { params: { activityId } } } = this.props
    // eslint-disable-next-line
    this.setState({ currentTab: pathname.indexOf('dynamic/') > 0 ? 1 : 0 })

    getActivityById({ activityId }).then(({ data = {} } = {}) => {
      this.setState({
        activityDetail: data,
        currentDynamicId: data.defaultDynamicId,
      })

      const { title, introduce: { description }, imgUrl } = data

      initializeNativeShare({
        imgUrl,
        title,
        description,
        url: href,
      })
    })
  }

  componentDidUpdate() {
    const { currentTab } = this.state
    const isDynamicPage =
      this.props.location.pathname.indexOf('dynamic/') > 0 ||
      this.props.location.search.indexOf('dynamicId=') >= 0

    if (currentTab === 0 && isDynamicPage) {
      this.setState({ currentTab: 1 })
    } else if (currentTab === 1 && !isDynamicPage) {
      this.setState({ currentTab: 0 })
    }
  }

  componentWillUnmount() {
    const pageRemainTime = new Date().getTime() - this.initPageDateTime
    za.trackPageShow({ id: 2046 }, { page: { elapsed: pageRemainTime } })
    this.initPageDateTime = null
    window.removeEventListener('load', this.handlePageInit)
  }
  handlePageInit = () => {
    initOpenInApp().catch()
  }

  changeDynamicId = id => {
    this.setState({ currentDynamicId: id })
  }

  renderActivityDetail = () => {
    const { currentDynamicId, activityDetail, currentTab } = this.state
    const {
      showType,
      defaultDynamicId,
      module: { activityDynamic, awardDeclare },
      organization,
    } = activityDetail
    const { match: { params: { activityId } } } = this.props
    const organizationName = organization[0].name || ''
    if (showType === 1) {
      // 流式布局
      return (
        <div className={styles.activityFlow}>
          <ActivityInstruction
            {...R.pickAll(introductionDataKeys, activityDetail)}
            activityId={activityId}
            currentDynamicId={currentDynamicId}
            changeDynamicId={value => this.changeDynamicId(value)}
          />
          {activityDynamic === 1 && (
            <ActivityParticipate
              dynamicId={currentDynamicId}
              organizationName={organizationName}
              hideAward={awardDeclare === 2}
            />
          )}
        </div>
      )
    } else if (showType === 2) {
      // type切换
      const { dynamicId } = urlParser.parse(window.location.href, true).query
      return (
        <Tabs
          tabs={[{ title: '活动说明' }, { title: '活动参与' }]}
          page={currentTab}
          tabBarBackgroundColor="#f7f7f7"
          tabBarActiveTextColor="#0084ff"
          tabBarUnderlineStyle={{ backgroundColor: '#0084ff' }}
          tabBarTextStyle={{ fontSize: 16 }}
          animated={false}
          swipeable={false}
          onTabClick={(tab, index) => {
            za.trackPageShow({ id: 2045 })
            if (currentTab !== index) {
              this.setState({ currentTab: index })
              this.props.history.replace(
                index
                  ? `/activity/${activityId}?dynamicId=${defaultDynamicId}`
                  : `/activity/${activityId}`
              )
            }
          }}
        >
          <ActivityInstruction
            {...R.pickAll(introductionDataKeys, activityDetail)}
            activityId={activityId}
          />
          <ActivityParticipate
            dynamicId={dynamicId}
            hideAward={awardDeclare === 2}
          />
        </Tabs>
      )
    }
    return null
  }

  render() {
    const { activityDetail } = this.state
    const { match: { params: { activityId } } } = this.props

    if (!activityDetail) {
      return null
    }

    const videoSize = {
      width: document.body.clientWidth,
      height: document.body.clientWidth / 16 * 9,
    }
    return (
      <div>
        <BannerModule
          {...R.pickAll(bannerDataKeys, activityDetail)}
          videoSize={videoSize}
        />
        <ActivityInfo
          id={activityId}
          {...R.pickAll(activitySummaryKeys, activityDetail)}
        />
        {this.renderActivityDetail()}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Activity/index.js